"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = '5.0.34';
//# sourceMappingURL=version.js.map